(function (d, w) {
  "use strict";
  // iPad and iPod detection
  var isiPad = function () {
    return navigator.platform.indexOf("iPad") != -1;
  };
  var isiPhone = function () {
    return (
      navigator.platform.indexOf("iPhone") != -1 ||
      navigator.platform.indexOf("iPod") != -1
    );
  };
  // Main Menu Superfish
  var mainMenu = function () {
    $("#fh5co-primary-menu").superfish({
      delay: 0,
      animation: {
        opacity: "show",
      },
      speed: "fast",
      cssArrows: true,
      disableHI: true,
    });
  };

  // Parallax
  var parallax = function () {
    $(window).stellar();
  };

  // Offcanvas and cloning of the main menu
  var offcanvas = function () {
    var $clone = $("#fh5co-menu-wrap").clone();
    $clone.attr({
      id: "offcanvas-menu",
    });
    $clone.find("> ul").attr({
      class: "",
      id: "",
    });

    $("#fh5co-page").prepend($clone);

    // // click the burger
    // $(".js-fh5co-nav-toggle").on("click", function () {
    //   if ($("body").hasClass("fh5co-offcanvas")) {
    //     $("body").removeClass("fh5co-offcanvas");
    //   } else {
    //     $("body").addClass("fh5co-offcanvas");
    //   }
    //   // $('body').toggleClass('fh5co-offcanvas');
    // });

    $("#offcanvas-menu").css("height", $(window).height());

    $(window).resize(function () {
      var w = $(window);

      $("#offcanvas-menu").css("height", w.height());

      if (w.width() > 769) {
        if ($("body").hasClass("fh5co-offcanvas")) {
          $("body").removeClass("fh5co-offcanvas");
        }
      }
    });
  };

  // Click outside of the Mobile Menu
  var mobileMenuOutsideClick = function () {
    $(document).click(function (e) {
      var container = $("#offcanvas-menu, .js-fh5co-nav-toggle");
      if (!container.is(e.target) && container.has(e.target).length === 0) {
        if ($("body").hasClass("fh5co-offcanvas")) {
          $("body").removeClass("fh5co-offcanvas");
        }
      }
    });
  };

  // Animations
  var contentWayPoint = function () {
    var i = 0;
    $(".animate-box").waypoint(
      function (direction) {
        if (direction === "down" && !$(this.element).hasClass("animated")) {
          i++;

          $(this.element).addClass("item-animate");
          setTimeout(function () {
            $("body .animate-box.item-animate").each(function (k) {
              var el = $(this);
              setTimeout(
                function () {
                  el.addClass("fadeInUp animated");
                  el.removeClass("item-animate");
                },
                k * 200,
                "easeInOutExpo"
              );
            });
          }, 100);
        }
      },
      { offset: "85%" }
    );
  };
  // Document on load.
  $(function () {
    mainMenu();
    if (!navigator.userAgent.match(/iPhone|Android.+Mobile/)) {
      parallax();
    }
    offcanvas();
    mobileMenuOutsideClick();
    contentWayPoint();

    setTimeout(function () {
      // do
    }, 8000);
  });
  //------------------------------------------------
  // pagespeed
  //------------------------------------------------
  var spd_check = false;

  var spd_link_array = [
    // "/assets/css/jquery.fs.boxer.css",
    "https://fonts.googleapis.com/css?family=Bitter&display=swap",
    // "/wp/wp-content/plugins/add-to-any/addtoany.min.css?ver=1.16",
  ];
  var spd_tag_array = [
    "/assets/js/jquery.easing.1.3.min.js",
    "/assets/js/bootstrap.min.js",
    // "/assets/js/jquery.waypoints.min.js",
    // "/assets/js/jquery.stellar.min.js",
    "/assets/js/hoverIntent.min.js",
    // "https://static.addtoany.com/menu/page.js",
    // "/wp/wp-content/plugins/add-to-any/addtoany.min.js?ver=1.1",

    "",
    // "/assets/js/superfish.min.js",
  ];
  var spd_script_array = [];

  var spd_css_check = false;
  function spd_css() {
    for (var i = 0, l = spd_link_array.length; i < l; i++) {
      var y = d.createElement("link");
      y.rel = "stylesheet";
      y.href = spd_link_array[i];
      d.head.appendChild(y);
    }
  }

  var spd_js_check = false;
  function spd_js() {
    for (var i = 0, l = spd_script_array.length; i < l; i++) {
      var y = d.createElement("script");
      y.async = false;
      y.src = spd_script_array[i];
      d.head.appendChild(y);
    }
  }

  var spd_tag_check = false;
  function spd_tag() {
    for (var i = 0, l = spd_tag_array.length; i < l; i++) {
      var y = d.createElement("script");
      y.async = false;
      y.src = spd_tag_array[i];
      d.head.appendChild(y);
    }
  }

  function spd_load_after(type) {
    if (spd_css_check === false && type == "css") {
      spd_css_check = true;
      w.removeEventListener("scroll", spd_load_after);
      w.removeEventListener("mousemove", spd_load_after);
      w.removeEventListener("mousedown", spd_load_after);
      w.removeEventListener("touchstart", spd_load_after);
      w.removeEventListener("keydown", spd_load_after);
      spd_css();
    }
    if (spd_js_check === false && type == "js") {
      spd_js_check = true;
      w.removeEventListener("scroll", spd_load_after);
      w.removeEventListener("mousemove", spd_load_after);
      w.removeEventListener("mousedown", spd_load_after);
      w.removeEventListener("touchstart", spd_load_after);
      w.removeEventListener("keydown", spd_load_after);
      spd_js();
    }
    if (spd_tag_check === false && type == "tag") {
      spd_tag_check = true;
      w.removeEventListener("scroll", spd_load_after);
      w.removeEventListener("mousemove", spd_load_after);
      w.removeEventListener("mousedown", spd_load_after);
      w.removeEventListener("touchstart", spd_load_after);
      w.removeEventListener("keydown", spd_load_after);
      spd_tag();
    }
  }

  function spd_load() {
    if (spd_check === false) {
      spd_check = true;
      w.removeEventListener("scroll", spd_load);
      w.removeEventListener("mousemove", spd_load);
      w.removeEventListener("mousedown", spd_load);
      w.removeEventListener("touchstart", spd_load);
      w.removeEventListener("keydown", spd_load);
      if (spd_css_check === false) {
        spd_css_check = true;
        spd_css();
      }
      if (spd_js_check === false) {
        spd_js_check = true;
        spd_js();
      }
      if (spd_tag_check === false) {
        spd_tag_check = true;
        spd_tag();
      }
    }
  }
  w.addEventListener("scroll", function () {
    if (w.pageYOffset) {
      spd_load();
    }
  });
  w.addEventListener("mousemove", spd_load);
  w.addEventListener("mousedown", spd_load);
  w.addEventListener("touchstart", spd_load);
  w.addEventListener("keydown", spd_load);
  w.addEventListener("load", function () {
    if (w.pageYOffset) {
      spd_load();
    }
  });
  setTimeout(function () {
    spd_load_after("css");
  }, 30000);
  setTimeout(function () {
    spd_load_after("js");
  }, 30000);
  setTimeout(function () {
    spd_load_after("tag");
  }, 5000);
})(document, window);
